import { buildCoreAssetUrl } from '../../../config/environment';

const isAbsoluteHttpUrl = (value: string) => /^https?:\/\//i.test(value);
const looksLikeSerializedJson = (value: string) => /^[[{]/.test(value.trim());

const resolveStringProfilePicture = (value: string): string | null => {
  const trimmed = value.trim();
  if (!trimmed || trimmed === 'null' || trimmed === 'undefined' || trimmed === '[object Object]') {
    return null;
  }

  if (looksLikeSerializedJson(trimmed)) {
    try {
      return resolveProfilePictureUrl(JSON.parse(trimmed));
    } catch {
      return null;
    }
  }

  if (isAbsoluteHttpUrl(trimmed)) {
    return trimmed;
  }

  return buildCoreAssetUrl(trimmed) || null;
};

const getUrlFromObject = (value: Record<string, unknown>): string | null => {
  const url = value.url;
  return typeof url === 'string' ? resolveStringProfilePicture(url) : null;
};

export const resolveProfilePictureUrl = (value: unknown): string | null => {
  if (value == null) return null;

  if (typeof value === 'string') {
    return resolveStringProfilePicture(value);
  }

  if (Array.isArray(value)) {
    const selectedItem = value.find(
      (item) =>
        item &&
        typeof item === 'object' &&
        !Array.isArray(item) &&
        (item as Record<string, unknown>).selected === true &&
        typeof (item as Record<string, unknown>).url === 'string'
    );

    if (selectedItem && typeof selectedItem === 'object') {
      const selectedUrl = getUrlFromObject(selectedItem as Record<string, unknown>);
      if (selectedUrl) return selectedUrl;
    }

    for (const item of value) {
      if (typeof item === 'string') {
        const resolved = resolveStringProfilePicture(item);
        if (resolved) return resolved;
      }

      if (item && typeof item === 'object' && !Array.isArray(item)) {
        const resolved = getUrlFromObject(item as Record<string, unknown>);
        if (resolved) return resolved;
      }
    }

    return null;
  }

  if (typeof value === 'object') {
    return getUrlFromObject(value as Record<string, unknown>);
  }

  return null;
};
